
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es/escuela-del-jamon/recetas",
      function () {
        return require("private-next-pages/es/escuela-del-jamon/recetas/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es/escuela-del-jamon/recetas"])
      });
    }
  